import { values } from 'lodash';

import {
  FormData,
  Form,
  Question,
  CaptureFields,
} from '../../models/leadads/form';
import { CallingCard } from '../../models/leadads/calling-card';
import { createRgJsonAPI } from '~/api/core/rgRequest';

const BUTTON_TYPE = 'VIEW_WEBSITE';

const leadAdsAPI = createRgJsonAPI('/leadads');
const leadFormsAPI = leadAdsAPI.appendPath('/lead_forms');

const postCallingCard = (pageId: string, link: string, callingCard: CallingCard): ResponseWith<CallingCard> => {
  const cardData = {
    title: callingCard.headline,
    body: callingCard.description,
    button_type: BUTTON_TYPE,
    button_text: callingCard.buttonText,
    website_url: fbLeadQuery(link),
  };

  return leadAdsAPI.appendPath('/thank_you_pages').post({
    pageId,
    form: cardData,
  });
};

const postLeadAdForm = (pageId: string, link: string, callingCard: CallingCard, form: FormData): ResponseWith<Form> => {
  const formData = {
    headline: form.callToAction,
    name: form.name,
    follow_up_action_url: link,
    legal_content_id: null,
    context_card_id: form.contextCardId,
    thank_you_page_id: callingCard.id,
    questions: extractCaptureFields(form.fields),
  };

  return leadFormsAPI.post({
    pageId,
    form: formData,
  });
};

export const getLeadAdForms = async (pageId: string): Promise<Form[]> => {
  try {
    const { data } = await leadFormsAPI.get({ pageId });

    return data;
  } catch (e) {
    throw new Error(e);
  }
};

function extractCaptureFields(captureFields: CaptureFields): Question[] {
  return values(captureFields)
    .filter(val => val !== false)
    .map(field => ({ type: field }));
}

function fbLeadQuery(url: string): string {
  const { search } = new URL(url);

  if (search.length === 0) {
    return `${url}?lead-ad`;
  }

  return `${url}&lead-ad`;
}

export const createNewForm = async (pageId: string, link: string, formData: FormData): Promise<Form> => {
  try {
    const { data: callingCard } = await postCallingCard(pageId, link, formData.callingCard);

    const { data } = await postLeadAdForm(pageId, link, callingCard, formData);

    return data;
  } catch (e) {
    throw new Error(e);
  }
};
